<script setup lang="ts">
defineOptions({
	name: 'GetResultsButton',
})

interface Props {
	isAnimating?: boolean
	disabled?: boolean
	loading?: boolean
	classBtn?: string
}

const props = withDefaults(defineProps<Props>(), {
	isAnimating: false,
	disabled: false,
	loading: false,
	classBtn: '',
})

const { t: $t } = useI18n()

const emit = defineEmits<{
	(e: 'click'): void
}>()

const classBase = computed(() => {
	return [
		props.classBtn,
		'group relative rounded-xl font-semibold',
		'transition-all duration-200',
		'active:scale-[0.98]',
		props.loading ? '' : 'hover:shadow-lg hover:shadow-[#00d66e]/20 hover:scale-[1.02]',
		props.isAnimating ? 'animate-pulse-ring' : '',
	].join(' ')
})
</script>

<template>
	<div class="relative">
		<div
			v-if="props.isAnimating"
			class="pointer-events-none absolute inset-0 -z-10"
		>
			<span class="absolute inset-0 rounded-full bg-[#00d66e] opacity-75 animate-ping-slow" />
			<span class="absolute inset-0 rounded-full bg-[#00d66e] opacity-50 animate-ping-slower" />
		</div>
		<UButton
			color="primary"
			variant="solid"
			:disabled="props.disabled"
			:loading="props.loading"
			:ui="{
				rounded: 'rounded-full',
				base: classBase,
			}"
			class="px-4 w-full flex justify-center"
			@click.stop="emit('click')"
		>
			<template #leading>
				<UIcon
					v-if="props.loading"
					name="i-heroicons:arrow-path-20-solid"
					class="w-5 h-5 animate-spin"
				/>
				<UIcon
					v-else
					:class="{ 'animate-bell-ring': props.isAnimating }"
					name="i-ph:bell-simple-ringing-bold"
					class="w-5 h-5"
				/>
			</template>

			<span>{{ $t('Join for free') }}!</span>
		</UButton>
	</div>
</template>
